import { useSelector } from "react-redux";
import {
    currentRolesSelector,
    currentUserEmailSelector,
} from "../../../redux/slices/auth/selectors";
import { BesuClaimState } from "../../../types/claim";
import { hasClaimAction } from "../../../utils/claim";
import { useMemo } from "react";

const useHasClaimAction = (claimState: BesuClaimState) => {
    const currentUserEmail = useSelector(currentUserEmailSelector);
    const currentRoles = useSelector(currentRolesSelector);
    const currentApproverInfo = useMemo(
        () =>
            claimState.claimApprovers?.find(
                (ca) => ca.details.email === currentUserEmail,
            ),
        [claimState.claimApprovers, currentUserEmail],
    );
    const isAtLeastOneInvoiceCreated = claimState.invoiceReferenceIds.length > 0;
    return {
        hasClaimAction: hasClaimAction(
            currentRoles,
            claimState.status,
            isAtLeastOneInvoiceCreated,
            currentApproverInfo?.status,
        ),
    };
};

export default useHasClaimAction;
